import { useDispatch } from 'react-redux';
import { systemActions } from '@/store/features';
import { MouseEvent, useEffect, useMemo } from 'react';

export const useModal = (unique_id?: string) => {
  const _id = unique_id || 'modal-' + Math.random();
  const dispatch = useDispatch();
  const { hideModal, showModal } = systemActions;

  useEffect(() => {
    const closeOnEscapeKeyDown = (e: { charCode: number; keyCode: number }) => {
      if ((e.charCode || e.keyCode) === 27) {
        dispatch(hideModal());
      }
    };

    document.body.addEventListener('keydown', closeOnEscapeKeyDown);
    return function cleanup() {
      document.body.removeEventListener('keydown', closeOnEscapeKeyDown);
    };
  }, []);

  return useMemo(
    () => ({
      id: _id,
      showModal: (id?: string) => dispatch(showModal(id || _id)),
      hideModal: () => dispatch(hideModal()),
      showModalByLink: (e: MouseEvent<HTMLAnchorElement>) => {
        if (
          e.currentTarget?.dataset?.modal === undefined ||
          e.currentTarget?.dataset?.modal === 'true'
        ) {
          e.preventDefault();
          dispatch(showModal(e.currentTarget?.href?.split('/').pop()));
        }
      },
    }),
    [_id],
  );
};
